import React, { Component } from 'react';
import { connect } from 'react-redux';
import StepCounterBox from '../../style/styledComponents/StepCounterBox';
import './index.scss';

class StepCounter extends Component {
	constructor() {
		super();

		this.state = {
			skipAddressForm: true,
			skipStyle: false,
			isEpay: false,
			isVivo: false,
			isCmDrConsulta: false,
			isSignatureChosen: false,
			isLevelled: false
		};
	}

	componentDidMount() {
		const planType = sessionStorage.getItem('planType');
		const {
			Plan: { list },
			GiftCode,
			VivoUser,
			Levelled,
			CmDrConsulta
		} = this.props;
		let hasUsedCard = list.some(
			plan => plan.used_card === '1' && plan.signature_type == planType
		);
		this.setState({ skipStyle: hasUsedCard, skipAddressForm: hasUsedCard });

		if (Object.keys(GiftCode.data).length > 0) {
			this.setState({ isEpay: true });
		} else if (Object.keys(VivoUser.data).length > 0) {
			this.setState({ isVivo: true });
		} else if (Object.keys(CmDrConsulta.data).length > 0) {
			this.setState({ isCmDrConsulta: true });
		} else if (Object.keys(Levelled.data).length > 0) {
			this.setState({ isLevelled: true });
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.Plan !== prevProps.Plan) {
			const planType = sessionStorage.getItem('planType');
			const {
				Plan: { list }
			} = this.props;
			let hasUsedCard = list.some(
				plan => plan.used_card === '1' && plan.signature_type == planType
			);
			this.setState({ skipStyle: !hasUsedCard });
			this.setState({ skipAddressForm: hasUsedCard });
		}

		const { SignatureChosen, CmDrConsulta } = this.props;

		if (!this.state.isSignatureChosen) {
			if (Object.keys(SignatureChosen.data).length > 0) {
				this.setState({ isSignatureChosen: true });
			}
		}
		if (!this.state.isCmDrConsulta) {
			if (Object.keys(CmDrConsulta.data).length > 0) {
				this.setState({ isCmDrConsulta: true });
			}
		}
	}

	render() {
		{
			/* logica que define o passo atual do usuario e quantidade de etapas de cada loja */
		}
		const counterStep =
			this.props.assinante === true
				? 1
				: this.props.endereco === true
				? 2
				: this.props.assinatura === true
				? 3
				: !this.state.isVivo &&
				  !this.state.isEpay &&
				  !this.state.isCmDrConsulta &&
				  !this.state.isSignatureChosen &&
				  !this.state.isLevelled &&
				  this.props.pagamento === true
				? 4
				: 3;
		const fullStep =
			!this.state.isVivo &&
			!this.state.isEpay &&
			!this.state.isCmDrConsulta &&
			!this.state.isSignatureChosen &&
			!this.state.isLevelled
				? 4
				: 3;
		return (
			<StepCounterBox>
				<div className='swiper-container'>
					<span>
						PASSO {counterStep} DE {fullStep}{' '}
					</span>
				</div>
			</StepCounterBox>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

export default connect(mapStateToProps)(StepCounter);
